//import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
//import SectionSliderNewCategories from "components/SectionSliderNewCategories/SectionSliderNewCategories";
import React, { FC } from "react";
import SectionGridFilterCard from "./SectionGridFilterCard";
import SectionTransferCard from "./SectionTransferCard";
import { Helmet } from "react-helmet";
import DavosHero from "./DavosHero";

export interface ListingDavosPageProps {
  className?: string;
}

const ListingDavosPage: FC<ListingDavosPageProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-ListingCarPage relative overflow-hidden ${className}`}
      data-nc-id="ListingCarPage"
    >
      <Helmet>
        <title>ETT || EUROPE TOURS & TRAVELS</title>
      </Helmet>
      <BgGlassmorphism />

      <DavosHero className="pt-10 lg:pt-16 " />

      <div className="container relative ">
       
       

        {/* SECTION */}
        <SectionGridFilterCard className="mt-24 mb-24 lg:space-y-28 lg:mb-28" />

        {/* SECTION 2 */}
        <SectionTransferCard className="pt-24 lg:pb-28" />
        {/* <div className="relative py-16">
        <SectionDisposalNewCategories
          heading="Transfer"
          subHeading=""
          categoryCardType="card5"
          itemPerRow={5}
          uniqueClassName="PageHome_s3"
        />
        </div> */}
        
      </div>
    </div>
  );
};

export default ListingDavosPage;
